export const ROLE_KEYS = {
  ADMIN: "admin",
  MONITOR: "monitor",
  TEACHER: "maestro",
  STUDENT: "alumno",
};

const item = (label, path, icon) => ({ label, path, icon });

export const ROLE_NAVIGATION = {
  [ROLE_KEYS.ADMIN]: {
    label: "Administrador",
    home: "/admin-home",
    profile: "/a-profile-page",
    accent: "#173f76",
    mainItems: [
      item("Calendario", "/calendar-page", "calendar"),
      item("Tutoriales", "/a-pagina-tutoriales", "tutorials"),
      item("Entregables", "/pagina-entregables-pdf", "deliverables"),
      item("Zoom", "/pagina-zoom", "video"),
    ],
    courseItems: [
      item("Foro de discusión", "/a-pagina-tablon", "forum"),
      item("Contenido", "/a-pagina-content", "content"),
      item("Ejercicios", "/a-pagina-tareas", "tasks"),
      item("Evaluación diagnóstica", "/a-pagina-evaluacion", "diagnostic"),
      item("Evaluación final", "/a-pagina-evaluacionfi", "final"),
      item("Zoom", "/a-pagina-zoom", "video"),
      item("Editar curso", "/a-edit-course", "edit"),
      item("Eliminar curso", "/a-delete-course", "delete"),
    ],
    extraItemsByPath: {
      "/a-pagina-tablon": [
        item("Generar constancia", "/certificado-form", "certificate"),
      ],
    },
  },
  [ROLE_KEYS.MONITOR]: {
    label: "Monitor",
    home: "/monitor-home",
    profile: "/m-profile-page",
    accent: "#246b65",
    mainItems: [
      item("Calendario", "/m-calendar-page", "calendar"),
      item("Tutoriales", "/m-pagina-tutoriales", "tutorials"),
      item("Entregables", "/m-pagina-entregables-pdf", "deliverables"),
      item("Zoom", "/pagina-zoom", "video"),
    ],
    courseItems: [
      item("Foro de discusión", "/m-pagina-tablon", "forum"),
      item("Contenido", "/m-pagina-content", "content"),
      item("Ejercicios", "/m-pagina-tareas", "tasks"),
      item("Evaluación diagnóstica", "/m-pagina-evaluacion", "diagnostic"),
      item("Evaluación final", "/m-pagina-evaluacionfi", "final"),
    ],
  },
  [ROLE_KEYS.TEACHER]: {
    label: "Maestro",
    home: "/teacher-home",
    profile: "/t-profile-page",
    accent: "#5b4b8a",
    mainItems: [
      item("Calendario", "/t-calendar-page", "calendar"),
      item("Tutoriales", "/t-pagina-tutoriales", "tutorials"),
      item("Entregables", "/t-pagina-entregables-pdf", "deliverables"),
      item("Zoom", "/pagina-zoom", "video"),
      item("Soporte", "/pagina-soporte", "support"),
    ],
    courseItems: [
      item("Foro de discusión", "/t-pagina-tablon", "forum"),
      item("Contenido", "/t-pagina-content", "content"),
      item("Ejercicios", "/t-pagina-tareas", "tasks"),
      item("Evaluación diagnóstica", "/t-pagina-evaluacion", "diagnostic"),
      item("Evaluación final", "/t-pagina-evaluacionfi", "final"),
      item("Zoom", "/t-pagina-zoom", "video"),
    ],
  },
  [ROLE_KEYS.STUDENT]: {
    label: "Estudiante",
    home: "/pagina-inicio",
    profile: "/profile-page",
    accent: "#1d5f9e",
    mainItems: [
      item("Calendario", "/calendar-page-s", "calendar"),
      item("Tutoriales", "/pagina-tutoriales", "tutorials"),
      item("Mis constancias", "/pagina-constancia", "certificate"),
      item("Zoom", "/pagina-zoom", "video"),
      item("Soporte", "/pagina-soporte", "support"),
    ],
    courseItems: [
      item("Foro de discusión", "/pagina-tablon", "forum"),
      item("Contenido", "/pagina-content", "content"),
      item("Ejercicios", "/pagina-tareas", "tasks"),
      item("Evaluación diagnóstica", "/pagina-evaluacion", "diagnostic"),
      item("Evaluación final", "/pagina-evaluacionfi", "final"),
      item(
        "Encuesta de satisfacción",
        "/pagina-encuesta-satisfaccion",
        "survey",
      ),
      item("Zoom", "/pagina-zoom", "video"),
    ],
  },
};

const ROLE_ALIASES = {
  admin: ROLE_KEYS.ADMIN,
  administrador: ROLE_KEYS.ADMIN,
  monitor: ROLE_KEYS.MONITOR,
  maestro: ROLE_KEYS.TEACHER,
  teacher: ROLE_KEYS.TEACHER,
  alumno: ROLE_KEYS.STUDENT,
  estudiante: ROLE_KEYS.STUDENT,
  student: ROLE_KEYS.STUDENT,
};

const COURSE_ROUTES = new Set([
  "/a-delete-course",
  "/a-edit-course",
  "/a-pagina-content",
  "/a-pagina-evaluacion",
  "/a-pagina-evaluacionfi",
  "/a-pagina-tablon",
  "/a-pagina-tareas",
  "/a-pagina-zoom",
  "/certificado-form",
  "/grade-homework",
  "/m-grade-homework",
  "/m-pagina-content",
  "/m-pagina-evaluacion",
  "/m-pagina-evaluacionfi",
  "/m-pagina-tablon",
  "/m-pagina-tareas",
  "/pagina-content",
  "/pagina-encuesta-satisfaccion",
  "/pagina-tablon",
  "/pagina-tareas",
  "/pagina-evaluacion",
  "/pagina-evaluacionfi",
  "/t-grade-homework",
  "/t-pagina-content",
  "/t-pagina-evaluacion",
  "/t-pagina-evaluacionfi",
  "/t-pagina-tablon",
  "/t-pagina-tareas",
  "/t-pagina-zoom",
]);

const ROLE_STORAGE_KEY = "gdp-navigation-role";

export const normalizeRole = (role) => {
  if (!role) {
    return null;
  }

  return ROLE_ALIASES[String(role).trim().toLowerCase()] || null;
};

const inferRoleFromPath = (pathname = "") => {
  if (
    pathname.startsWith("/a-") ||
    pathname === "/admin-home" ||
    pathname === "/calendar-page" ||
    pathname === "/grade-homework"
  ) {
    return ROLE_KEYS.ADMIN;
  }

  if (pathname.startsWith("/t-") || pathname === "/teacher-home") {
    return ROLE_KEYS.TEACHER;
  }

  if (pathname.startsWith("/m-") || pathname === "/monitor-home") {
    return ROLE_KEYS.MONITOR;
  }

  return null;
};

export const rememberNavigationRole = (role) => {
  const normalizedRole = normalizeRole(role);

  if (normalizedRole && typeof window !== "undefined") {
    window.sessionStorage.setItem(ROLE_STORAGE_KEY, normalizedRole);
  }

  return normalizedRole;
};

export const clearNavigationRole = () => {
  if (typeof window !== "undefined") {
    window.sessionStorage.removeItem(ROLE_STORAGE_KEY);
  }
};

export const resolveNavigationRole = (role, pathname = "") => {
  const normalizedRole = normalizeRole(role);

  if (normalizedRole) {
    return normalizedRole;
  }

  if (typeof window !== "undefined") {
    const storedRole = normalizeRole(
      window.sessionStorage.getItem(ROLE_STORAGE_KEY),
    );

    if (storedRole) {
      return storedRole;
    }
  }

  return inferRoleFromPath(pathname) || ROLE_KEYS.STUDENT;
};

export const isCourseRoute = (pathname = "") => COURSE_ROUTES.has(pathname);

export const getRoleNavigation = (role, pathname = "") => {
  const roleKey = resolveNavigationRole(role, pathname);
  return { roleKey, ...ROLE_NAVIGATION[roleKey] };
};

export const getNavigationItems = (role, pathname = "") => {
  const navigation = getRoleNavigation(role, pathname);
  const baseItems = isCourseRoute(pathname)
    ? navigation.courseItems
    : navigation.mainItems;
  const extraItems = navigation.extraItemsByPath?.[pathname] || [];

  return [...baseItems, ...extraItems];
};